<template>
    <div class="row mt-5">

        <div class="col-12 text-center">
            <div class="font-weight-light text-left">(*) Mention obligatoire</div>
            <b-button
                variant="outline-secondary"
                size="lg"
                class="mr-3"
                @click="goBack">
                <b-icon icon="chevron-left" aria-hidden="true"></b-icon> {{ backLabel }}
            </b-button>

            <span v-if="!buttons.next" id="tooltip-btn-next-disabled" class="d-inline-block" tabindex="0">
                <b-button
                    variant="primary"
                    size="lg"
                    class="ml-3"
                    disabled>
                    {{ nextLabel }} <b-icon icon="chevron-right" aria-hidden="true"></b-icon>
                </b-button>
                <b-tooltip target="tooltip-btn-next-disabled" triggers="hover">
                    Veuillez compléter toutes les informations pour passer à l'étape suivante
                </b-tooltip>
            </span>

            <b-button v-else
                variant="primary"
                size="lg"
                class="ml-3"
                @click="goNext">
                {{ nextLabel }} <b-icon icon="chevron-right" animation="cylon" aria-hidden="true"></b-icon>
            </b-button>

        </div>
    </div>
</template>

<script>
export default {
    name: 'BackNext',
    props: [
        'buttons'
    ],
    computed: {
        backLabel: function() {
            return (this.buttons.labels && this.buttons.labels.back) ? this.buttons.labels.back : 'Précédent'
        },
        nextLabel: function() {
            return (this.buttons.labels && this.buttons.labels.next) ? this.buttons.labels.next : 'Suivant'
        }
    },
    methods: {
        goBack() {
            this.$actions.router(this.buttons.routes.back)
        },
        goNext() {
            this.$actions.router(this.buttons.routes.next)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/BackNext.vue